import request from '@/utils/request'

// 查询联系方式列表
export function listYlqxcxLxfs(query) {
  return request({
    url: '/web/zlts/ylqxcx/lxwm/list',
    method: 'get',
    params: query
  })
}